// import { createSlice } from "@reduxjs/toolkit";

// const themeSlice = createSlice({
//   name: "theme",
//   initialState: {
//     current: "#162f06", // default green
//   },
//   reducers: {
//     setTheme: (state, action) => {
//       state.current = action.payload;
//     },
//   },
// });

// export const { setTheme } = themeSlice.actions;
// export default themeSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";

// ── Read persisted theme from localStorage on startup ──────────
const savedTheme = localStorage.getItem("aqwf_theme");

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    current: savedTheme || "#162f06", // persisted or default green
  },
  reducers: {
    setTheme: (state, action) => {
      state.current = action.payload;
      // Persist to localStorage so it survives page reloads
      localStorage.setItem("aqwf_theme", action.payload);
    },
  },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;